// extracted by mini-css-extract-plugin
export default {"items":"ItemList_items__7dH2r","quantity":"ItemList_quantity__WotnN","name":"ItemList_name__gnqRT","expiry":"ItemList_expiry__dPgg-"};